import React from "react";
import { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
function Plan() {
  const {
    cliente,
    cursoscomprados,
    productos,
    traemeColorClub,
    colorClub,
    tipo_plan,
  } = useContext(Contexto);

  const [tuColorClub, setTuColorClub] = useState(false);
  const [precio, setPrecio] = useState(0);

  useEffect(() => {
    if (cursoscomprados.hasOwnProperty("color-club")) {
      setTuColorClub(cursoscomprados["color-club"]);
    } else {
      setTuColorClub(false);
    }
  }, [cursoscomprados]);

  useEffect(() => {
    let productoSeleccionado = productos.filter(
      (ite) => ite.nombre === "Suscripción mensual a Color Club"
    );
    console.log("productoSeleccionado:", productoSeleccionado);
    setPrecio(productoSeleccionado[0]);
  }, [productos]);

  let handleClick = () => {};
  return (
    <>
      <div className="soporteLogin">
        <div className="login">
          <div className="login__wrapper ">
            <p className="titFelicitaciones">Tu acceso al Club</p>
            {tuColorClub && !tipo_plan.mensual ? (
              <>
                Última compra: {tipo_plan.fecha} <br />
                Días restantes: {tuColorClub.restantes} <br />
                <br />
              </>
            ) : (
              <>
                <p>Suscripción mensual</p>
                fecha de cobro el dia {tipo_plan.vencimiento} de cada mes.{" "}
                <br />
                Valor actual: <br /> AR$ {precio.precio} / U$D {precio.dolar}
                <p>Si querés cancelar tu suscripción mensual:</p>
                <a
                  className="formuBT"
                  href="https://www.mercadopago.com.ar/subscriptions"
                  target="_blank"
                >
                  CANCELAR SUSCRIPCIÓN
                </a>
                <br />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Plan;
